/*
 * @Description: 附件管理
 * @Author: fxg
 * @Date: 2020-06-29 11:18:28
 * @LastEditors: fxg
 * @LastEditTime: 2020-06-29 13:34:36
*/
import request from '@/utils/request'
export const Download = "/base/system/code/rules/export";
export function batchUpdateOrDelete(data) {
  return request({
    url: '/base/system/code/rules/batch_update_or_delete',
    method: 'post',
    data
  })
}
export function getDetail(params) {
  return request({
    url: '/base/system/code/rules/get_detail',
    method: 'get',
    params
  })
}
export function queryPage(data) {
  return request({
    url: '/base/system/code/rules/query_page',
    method: 'post',
    data
  })
}
export function saveOrUpdate(data) {
  return request({
    url: '/base/system/code/rules/save_or_update',
    method: 'post',
    data
  })
}
